import * as bookingList from './BookingListAction';
import * as userConfig from './UserConfigAction';

export const bookingListAction = bookingList;
export const userConfigAction = userConfig;